export const FileExtension = (file)=>{
    return file?.slice(file?.lastIndexOf("."))
}